import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import {
  DatePicker,
  TimeSelect,
  TimePicker,
  Select,
  Option,
  Button,
  Upload,
  Loading,
  Pagination,
  Input
} from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/vi'
import locale from 'element-ui/lib/locale'
import '@/assets/styles/element-variables.scss'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/styles/main.css'

import * as filters from './filters'

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

locale.use(lang)
Vue.component(Input.name, Input)
Vue.component(DatePicker.name, DatePicker)
Vue.component(TimeSelect.name, TimeSelect)
Vue.component(TimePicker.name, TimePicker)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Button.name, Button)
Vue.component(Upload.name, Upload)
Vue.component(Pagination.name, Pagination)
Vue.use(Loading.directive)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(DatePicker)

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
